import { render } from "./ForgetView.vue?vue&type=template&id=cad4db92"
import script from "./ForgetView.vue?vue&type=script&lang=js"
export * from "./ForgetView.vue?vue&type=script&lang=js"

import exportComponent from "/home/user_ui/taichung_main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__